import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "field"]
  static values = {
    other: {type: String, default: "other"},
    class: {type: String, default: "hidden"}
  }

  connect() {
    // set initial state
    this.setupOtherCheckbox()
    this.update()
  }

  setupOtherCheckbox() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.value == this.otherValue) {
        checkbox.dataset.action = "change->other#update"
      } else {
        delete checkbox.dataset.otherTarget
      }
    })
  }

  update() {
    this.fieldTarget.classList.toggle(this.classValue, !this.checkboxTarget.checked)

    if (this.checkboxTarget.checked) {
      this.fieldTarget.querySelector("input").focus()
    }
  }
}
